export default {
  timeFormat (VueApp, withSeconds) {
    if (withSeconds) {
      return VueApp.$settings.config && VueApp.$settings.get('MilitaryTimeBackoffice') === 1 ? 'HH:mm:ss' : 'hh:mm:ss A'
    }
    return VueApp.$settings.config && VueApp.$settings.get('MilitaryTimeBackoffice') === 1 ? 'HH:mm' : 'hh:mmA'
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/featureToggle.js